export default {
  title: 'Información del médico',
  titleDescription: 'Complete la siguiente información para poder continuar',
  nameLabel: 'Nombre y Apellido',
  specialtyLabel: 'Especialidad',
  license: 'Exequatur',
  countryLabel: 'Pais'
  
}